import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useAppParams = () => {
  // Accessing appVariant and source from Redux state
  const appVariant = useSelector((state: RootState) => state.app.appVariant);
  const source = useSelector((state: RootState) => state.app.source);

  // Returning the app parameters in an object
  return { appVariant, source };
};

export default useAppParams;
